export default "__VITE_ASSET__e64b17aa__"